module.exports = __webpack_public_path__ + "static/media/circle_yellow.518f2a62.png";